/* istanbul ignore file */
import { ReactComponent as ArrowDownImage } from 'assets/icons/action/arrow_down_rounded.svg';
import { ReactComponent as ArrowRightImage } from 'assets/icons/action/arrow_right_rounded.svg';
import { ReactComponent as PauseIconSVG } from 'assets/icons/action/pause_rounded.svg';
import { ReactComponent as PlayIconSVG } from 'assets/icons/action/play_arrow_rounded.svg';
import { ReactComponent as TimerSVG } from 'assets/icons/action/timer.svg';
import { ReactComponent as UserActionDeniedSvg } from 'assets/icons/action/userActionDenied.svg';
import { ReactComponent as HiLogoWithTextSVG } from 'assets/icons/logo/HiLogoWithText.svg';
import hiScribeImage from 'assets/icons/logo/Huma Intelligence 40x40.svg';
import hiCopilotLogo from 'assets/icons/logo/hi_copliot_logo.svg';
import eCLogoImage from 'assets/img/eCBubbleLogo.png';
import React from 'react';

interface HiScribeCopilotLogoProps {
  style?: React.CSSProperties;
}
export const UnableToManageStateSvg = ({ className }: { className?: string }) => (
  <UserActionDeniedSvg className={className} />
);

export const EcLogo = () => <img src={eCLogoImage} alt="eConsult logo" data-automation="EconsultLogo" />;

export const HiScribeLogo = () => (
  <img src={hiScribeImage} alt="Huma Intelligence Scribe logo" data-automation="HiScribeLogo" />
);

export const HiScribeCopilotLogo: React.FC<HiScribeCopilotLogoProps> = ({ style }) => (
  <img src={hiCopilotLogo} alt="Huma Intelligence logo" data-automation="HiCopilotLogo" style={style} />
);

export const ArrowDownIcon = ({ className }: { className?: string }) => (
  <ArrowDownImage className={className} alt="Arrow down icon" data-automation="ArrowDownIcon" />
);

export const ArrowRightIcon = ({ className }: { className?: string }) => (
  <ArrowRightImage className={className} alt="Arrow right icon" data-automation="ArrowRightIcon" />
);

export const PauseIcon = ({ className }: { className?: string }) => (
  <PauseIconSVG data-automation="PauseIconSVG" className={className} />
);

export const StartIcon = ({ className }: { className?: string }) => (
  <PlayIconSVG data-automation="PlayIconSVG" className={className} />
);

export const HiLogoWithTextIcon = ({ className }: { className?: string }) => (
  <HiLogoWithTextSVG data-automation="HiLogoWithTextSVG" className={className} />
);

export const TimerIcon = ({ className }: { className?: string }) => (
  <TimerSVG data-automation="TimerSVG" className={className} />
);

HiScribeCopilotLogo.defaultProps = {
  style: {},
};
